export const version = 'v2.2.4-2278-g32bc725a4'
